<template>
    <transition>
        <div v-if="mlSearch!=null" class="center-content mlcity_wrap">
            <!-- <div class="book-option-wrapper">
              <div class="booking-option">
                <div class="img">
                  <img src="@imgPath/img/svg/icons/take-off.svg" width="17px" />
                </div>
                <div class="text">{{$t('searchPage.headerFlight')}}</div>
              </div>
            </div>-->
            <div class="ml-wrap" @click="isPaxViewOpen=false" >
<!--              <div :class = "(isHoveringRf==true && mlSearch.route > multiCityLength.min) ? 'removeHoverFlight'-->
<!--                : mlSearch.route < multiCityLength.max ? 'disableadbtn' : null" >-->


                <div :class="{removeHoverFlight: isHoveringRf == true && mlSearch.route.length>multiCityLength.min}" class="ml-route-wrapper"
                     >
                    <div class="main-search" v-for="(routeObj,index) in mlSearch.route" :key="'trip'+index">
                        <div class="place">
                            <div class="form">
                                <label class="typo__label">{{$t('searchPage.from')}}</label>
                                <multiselect
                                        :id="'fromML'+index"
                                        :allow-empty="false"
                                        :showLabels="false"
                                        :clearOnSelect="false"
                                        v-model="routeObj.from"
                                        :options="lsCountryRoute.length>0?lsCountryRoute:[]"
                                        :multiple="false"
                                        group-values="routeList"
                                        group-label="country"
                                        :group-select="false"
                                        :placeholder="$t('searchPage.searchPlaceHolder')"
                                        track-by="depcode"
                                        v-on:input="getArrivalRoutes(routeObj.from,index,false)"
                                        v-on:close="triggerArrCityPicker"
                                        v-on:open="triggerFlightDatePicker"
                                        ref="fromMLCityPicker"
                                        :searchable="true"
                                        :custom-label="cityPickCustomeLabel"
                                        @search-change="addCssClass()"
                                >
                                    <template
                                            slot="singleLabel"
                                            slot-scope="{ option }"
                                    >{{ option.depcode.city}} ({{option.depcode.airportcode}})
                                    </template>
                                    <template slot="option" slot-scope="props">
                                        <div>
                                            <span v-if="props.option.$isLabel">{{ props.option.$groupLabel.value }}</span>
                                            <span v-else>
                      {{ props.option.depcode.city}}
                      <strong
                              v-if="props.option.depcode"
                              class="right"
                      >{{ props.option.depcode.airportcode }}</strong>
                    </span>
                                        </div>
                                    </template>
                                    <span slot="noResult"><strong>{{ $t("noMatchFound.noMatchFound") }}</strong></span>
                                </multiselect>
                            </div>
                            <div class="center-icon" @click="rotate(index)" :key="index">
                                <img src="@imgPath/img/png/flight.png" alt/>
                                <img
                                        src="@imgPath/img/png/flight-round.png"
                                        alt
                                        id="rotate-icon"
                                        :class="{'re_rotate' : rotateIconActiveLs[index]?rotateIconActiveLs[index].isRotate:rotateIconActiveLs[index] }"
                                />
                            </div>
                            <div class="to">
                                <label class="typo__label">{{$t('searchPage.to')}}</label>
                                <multiselect
                                        :id="'toML'+index"
                                        :allow-empty="false"
                                        :showLabels="false"
                                        :clearOnSelect="false"
                                        v-model="routeObj.to"
                                        :options="lsArrival.length>0&&lsArrival[index]&&lsArrival[index].length>0?lsArrival[index]:[]"
                                        :multiple="false"
                                        group-values="routeList"
                                        group-label="country"
                                        :group-select="false"
                                        :placeholder="$t('searchPage.searchPlaceHolder')"
                                        track-by="depcode"
                                        v-on:input="assignArrToSearch(routeObj.to,index,false)"
                                        v-on:open="triggerDepCityPicker(index)"
                                        v-on:close="openDatePicker(index)"
                                        ref="toMLCityPicker"
                                        :searchable="true"
                                        :custom-label="cityPickCustomeLabel"
                                        @search-change="addCssClass()"
                                >
                                    <template
                                            slot="singleLabel"
                                            slot-scope="{ option }"
                                    >{{ option.depcode.city}} ({{option.depcode.airportcode}})
                                    </template>
                                    <template slot="option" slot-scope="props">
                                        <div>
                                            <span v-if="props.option.$isLabel">{{ props.option.$groupLabel.value }}</span>
                                            <span v-else>
                      {{ props.option.depcode.city}}
                      <strong
                              v-if="props.option.depcode"
                              class="right"
                      >{{ props.option.depcode.airportcode }}</strong>
                    </span>
                                        </div>
                                    </template>
                                    <span slot="noResult"><strong>{{ $t("noMatchFound.noMatchFound") }}</strong></span>
                                    <span slot="noOptions">{{routeObj&&routeObj.from?$t('searchPage.noArrivalsFound'):$t('searchPage.selectDeparture')}}</span>
                                </multiselect>
                            </div>
                        </div>
                        <div class="date" :class="'oneway'">
                            <label class="typo__label depart">{{$t('searchPage.journeyDate')}}</label>
                            <!-- <label class="typo__label return" v-if="search.trip==jTypeTabs[1].code">Return</label> -->
                            <!-- :endingDateValue="search.trip==jTypeTabs[1].code?new Date(search.route[1].date):null" -->
                            <!-- @check-out-changed="getToDate" -->
                            <!-- :enableCheckout="search.trip==jTypeTabs[1].code?
                            true:false"-->
                            <HotelDatePicker :id="'datePick'+index" :key="'datePick'+index" 
                                    v-if="isDatePicShow"    
                                    :showYear="true"
                                    :startDate="getStartDate(index)"
                                    :hoveringTooltip="false"
                                    :displayClearButton="false"
                                    format="dddd, MMM DD"
                                    @check-in-changed="getFromDate($event, index)"
                                    :singleDaySelection="true"
                                    :i18n="assigni18nObjByLang(index)"
                                    :ref="'flightDatePicker'+index"
                                    :minNights="1"
                                    :closeDatepickerOnClickOutside="isCloseOutsideClick"
                            />
                                   <!-- :startingDateValue="new Date(mlSearch.route[index].date)" -->
                        </div>


                    </div>

                </div>
                <div class="remove-flight-btn-wrap" v-if="mlSearch.route.length>multiCityLength.min"
                     @click="onRemoveFlight" @mouseover="isHoveringRf = true" @mouseout="isHoveringRf = false">
                    <img src="@imgPath/img/svg/icons/cross-red.svg" alt="">
                </div>
                <div class="">
                    <div class="d-flex">

                        <div class="add-ml-flight"  @click="onRemoveFlight" @mouseover="isHoveringRf = true" @mouseout="isHoveringRf = false" v-if="mlSearch.route.length>=multiCityLength.max">
                            <img src="@imgPath/img/svg/icons/remove--red.svg" alt=""> <span style="color:red;">
                            Remove Flight
                        </span>
                        </div>

                        <div class="add-ml-flight"  :class="{disable : mlSearch.route.length>=multiCityLength.max}" v-else
                             @click="onAddFlight">
                            <img src="@imgPath/img/svg/icons/blue-icons/circle_add.svg" alt=""> {{$t('searchPage.addAnotherFlight')}}
                        </div>
                        <!--              <button class="multicity-ext-btn" >Add another flight</button>-->

                        <!--              <button class="multicity-ext-btn"  >Remove flight</button>-->

                        <!-- <div class="col-md-3">
                          <button @click="onSearchFlights">Search</button>
                        </div>-->
                    </div>
                </div>

                <!-- <div :show="alertValue!=null" class="search_error_message">{{alertValue}}</div> -->
            </div>
        </div>
    </transition>
</template>
<script>
    import Vue from "vue";
    import {handleJWT, getErrorAlertValue} from "../../../util/util";

    import {
        getFlightSearchHisFromLocal,
        setFlightSearchHisToLocal
    } from "../../../applocalstorage/localStorage";
    import VueNumberInput from "@chenfengyuan/vue-number-input";
    import {
        dateFunctions,
        getDiffBtwDates,
        addDays,
        formatDate
    } from "../../../util/date/dateFunctions";
    import cCurrencyDropDown from "../../../components/currency/cCurrencyDropDown";

    import {
        TRIP,
        PAX,
        PAX_COUNT,
        LOCAL_STORAGE_KEYS,
        CITIZEN,
        TOAST_TYPE,ALL_CLIENT_CODE
    } from "../../../util/constants.js";
    import cRadioButton from "../../form/cRadioButton";
    import cOrgCurrencyDp from "../../currency/cOrgCurrencyDp";

    import Logger from "../../../services/logger";
    import apiGetRoutes from "../../../services/apiGetRoutes.js";
    // import apiSearchResult from "../../../../services/apiSearchResult.js";

    import {VALIDATE_SUCCESS_RES, getErrorMessage} from "@/util/apiValidate.js";
    import router, {navigate, goBack} from "../../../router/index";
    import { i18n } from "../../../plugins/i18n.js";
    import {
        LOG_TYPE,
        FILE_NAME,
        HTTP_CODES,
        API_VALUES
    } from "../../../config/API_DATA";
    import {COMPONENT_NAME, PATHNAME} from "../../../util/constants";
    import BaseConfiguration from "../../../config/base.js";
    import SERVICE_URL from "../../../config/API_DATA";

    import HotelDatePicker from "vue-range-datechooser";
    import Multiselect from "vue-multiselect";
    import {GroupByList, cloneData, cloneDeep} from "../../../util/util.js";
    import {mapGetters, mapActions} from "vuex";

    Vue.use(VueNumberInput);

    export default {
        name: COMPONENT_NAME.C_ML_SEARCH,
        components: {
            HotelDatePicker,
            Multiselect,
            cCurrencyDropDown,
            cOrgCurrencyDp,
            cRadioButton
            
        },
        props: {
            isBackdropAdded: {
                type: Boolean,
                default: false
            },
            searchMlObj: {
                type: Object,
                default: null
            }
        },
        data: () => ({
            clientCode:BaseConfiguration.clientCode,
      allClientCode:ALL_CLIENT_CODE,
            isHoveringRf: false,
            multiCityLength: {
                min: BaseConfiguration.multiCityLength.min,
                max: BaseConfiguration.multiCityLength.max
            },

            rotateIconActiveLs: [],
            isSwapLoading: false,
            // swapIndex: null,

            citizenObj: null,
            // isFlIconRotate: false,
            isPaxViewOpen: false,
            isDatePicShow: true,
isCloseOutsideClick:true,
            lsCitizenCategory: [
      {
        name: 'Yes',
        code: "Y"
      },
      {
        name: 'No',
        code: "N"
      }
    ],

    lsAirlineClass: [
      {
        name: i18n.tc('searchPage.economy'),
        code: "E/PE"
      },
      {
        name: i18n.tc('searchPage.buisness'),
        code: "B"
      },
      {
        name: i18n.tc('searchPage.buisFirst'),
        code: "B/F"
      },
      {
        name:  i18n.tc('searchPage.premium'),
        code: "PE"
      },
      {
        name:  i18n.tc('searchPage.first'),
        code: "F"
      }
    ],

    jTypeTabs: [
      {
        name:  i18n.tc('searchPage.oneWay'),
        code: TRIP.ONE_WAY
      },
      {
        name: i18n.tc('searchPage.roundTrip'),
        code: TRIP.ROUND_TRIP
      },
      {
        name:  i18n.tc('searchPage.multiCity'),
        code: TRIP.MULTI_CITY
      }
    ],
            // alertValue: null,
            lsCountryRoute: [],
            lsArrival: [],
            routesResponse: null,
            defaultCurrencyCode: null,

            //searchHistory: [],
            //isClearSearchHistory: false,
            // showAlert: false,
            alertValue: null,
            currentAlertCounter: 0,

            mlSearch: {
                trip: BaseConfiguration.defaultTrip,
                route: [
                    {
                        from: null,
                        to: null,
                        date: new Date()
                    }
                ],
                class: null,
                pax: {
                    adultCount: 1,
                    childCount: 0,
                    infantCount: 0
                },
                citizen: null,
                currency: null
            },
            active: false,
           
            newlyAdded:false
        }),
        watch: {
            isBackdropAdded(newVal, oldVal) {
                if (newVal === false) {
                    this.closeAllPopups();
                }
            },

            mlSearch: {
                immediate: false,
                deep: true,
                handler: function (newVal, oldVal) {
                    this.SET_ML_SEARCH_OBJ(this.mlSearch);
                    // console.error(this.mlSearch)
                }
            }
        },

        methods: {
            ...mapActions("sCSearch", ["SET_ROUTES_OBJ"]),
            ...mapActions("sCMultiCitySearch", {
                SET_ML_SEARCH_OBJ: "SET_ML_SEARCH_OBJ",
                SET_ML_ARR_LS: "SET_ML_ARR_LS"
            }),

        
            getStartDate(pIndex) {
                let retValue;
                try {
                    if (BaseConfiguration.isDebug) console.log("getStartDate");
                    // if(pIndex==1)
                    if (
                        this.mlSearch &&
                        this.mlSearch.route &&
                        this.mlSearch.route[pIndex] &&
                        this.mlSearch.route[pIndex].date
                    ) {
                        if (pIndex == 0) {
                            retValue = new Date();
                        } else {
                            retValue = new Date(this.mlSearch.route[pIndex - 1].date);
                        }
                        
                        // console.error(
                        //   this.$refs.flightDatePicker[pIndex - 1].startingDateValue,
                        //   pIndex
                        // );
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_ML_SEARCH,
                        "error in getStartDate",
                        err.toString(),
                        "getStartDate",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },
            // getStartingDateValue(pIndex) {
            //     let retValue;
            //     try {
            //       if(BaseConfiguration.isDebug) console.log("getStartingDateValue");
            //    retValue= this.mlSearch.route[pIndex].date

            //     } catch (err) {
            //             let body = Logger.buildRequest(
            //              COMPONENT_NAME.C_ML_SEARCH,
            //               "error in getStartingDateValue",
            //               err.toString(),
            //               "getStartingDateValue",
            //               LOG_TYPE.ERROR
            //             );
            //             Logger.getResponse(body);
            //           }
            //       return retValue;
            //     },
            ///
            // onSearchFlights() {
            //   try {
            //     if (BaseConfiguration.isDebug) console.log("onSearchFlights");
            //     this.SET_ML_SEARCH_OBJ(this.mlSearch);
            //     this.$emit("getMlSearchObj", this.mlSearch);
            //     if (BaseConfiguration.isDebug) console.log(this.mlSearch);
            //   } catch (err) {
            //     let body = Logger.buildRequest(
            //       COMPONENT_NAME.C_ML_SEARCH,
            //       "error in onSearchFlights",
            //       err.toString(),
            //       "onSearchFlights",
            //       LOG_TYPE.ERROR
            //     );
            //     Logger.getResponse(body);
            //   }
            // },

            ///
            onAddFlight() {
                try {
                    if (BaseConfiguration.isDebug) console.log("onAddFlight");
                    if (
                        this.mlSearch.route.length < BaseConfiguration.multiCityLength.max
                    ) {
                        let routeObj = this.getDefaultRouteObj(
                            this.mlSearch.route[this.mlSearch.route.length - 1]
                        );
                        this.mlSearch.route.push(routeObj);
                        this.rotateIconActiveLs.push({isRotate: false});


                        this.getArrivalLsForDep(
                            this.mlSearch,
                            this.mlSearch.route.length - 1
                        );
                        this.newlyAdded=true;
                    }
                    
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_ML_SEARCH,
                        "error in onAddFlight",
                        err.toString(),
                        "onAddFlight",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            getArrivalLsForDep(pSearch, pIndex) {
                let searchObj = pSearch;
                try {
                    if (BaseConfiguration.isDebug) console.log("getArrivalLsForDep");
                    // let retValue;
                    if (searchObj && searchObj.route[pIndex].from) {
                        let fromPlace = cloneData(searchObj.route[pIndex].from);
                        // let fromPlace = pSearch.route[pIndex].to;

                        depListIndex: for (
                            let index = 0;
                            index < this.lsCountryRoute.length;
                            index++
                        ) {
                            const depList = this.lsCountryRoute[index].routeList;
                            depIndex: for (let index = 0; index < depList.length; index++) {
                                const dep = depList[index];
                                if (
                                    fromPlace &&
                                    dep.depcode.airportcode == fromPlace.depcode.airportcode
                                ) {
                                    searchObj.route[pIndex].from = dep;
                                    this.getArrivalRoutes(searchObj.route[pIndex].from, pIndex, false);
                                    break depListIndex;
                                }
                            }
                        }
                        // let toPlace=pSearch.route[0].to;
                        // if (this.lsArrival.length > 0 && this.lsArrival[pIndex]) {
                        //   for (
                        //     let index = 0;
                        //     index < this.lsArrival[pIndex].length;
                        //     index++
                        //   ) {
                        //     const arrList = this.lsArrival[pIndex][index].routeList;
                        //     for (let index = 0; index < arrList.length; index++) {
                        //       const arr = arrList[index];
                        //       if (arr.depcode.airportcode == toPlace.depcode.airportcode) {
                        //         searchObj.route[pIndex].to = arr;
                        //         this.assignArrToSearch(searchObj.route[pIndex].to, pIndex);
                        //       }
                        //     }
                        //   }
                        // }
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_SEARCH,
                        "error in getArrivalLsForDep",
                        err.toString(),
                        "getArrivalLsForDep",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return searchObj;
            },

            ///
            onRemoveFlight() {
                try {
                    if (BaseConfiguration.isDebug) console.log("onRemoveFlight");
                    if (
                        this.mlSearch.route.length > BaseConfiguration.multiCityLength.min
                    ) {
                        this.$delete(this.rotateIconActiveLs, this.mlSearch.route.length - 1);
                        this.$delete(this.mlSearch.route, this.mlSearch.route.length - 1);
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_ML_SEARCH,
                        "error in onRemoveFlight",
                        err.toString(),
                        "onRemoveFlight",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

           
            // closeAllPopups() {
            //   this.isPaxViewOpen = false;
            //   //this.$refs.flightDatePicker.isOpen = false;
            //   this.$refs.fromMLCityPicker.deactivate();
            //   this.$refs.toMLCityPicker.deactivate();
            // },

            // closePaxView() {
            //   this.isPaxViewOpen = false;
            // },
            // onToggleBackdrop(open) {
            //   this.$root.$emit("toggle_backdrop", open);
            // },
            cityPickCustomeLabel(option) {
                return `${option.depcode.city} — [${option.depcode.airportcode}]`;
            },
            ///to change class of city picker
            addCssClass() {
                //
                try {
                    if (BaseConfiguration.isDebug) console.log("addCssClass");

                    let countryTitleLIst = document.getElementsByClassName(
                        "multiselect__option--disabled"
                        //"multiselect__option multiselect__option--group multiselect__option--disabled"
                    );
                    setTimeout(() => {
                        for (let index = 0; index < countryTitleLIst.length; index++) {
                            const element = countryTitleLIst[index];
                            element.parentNode.classList.add("active");
                        }
                    }, 100);
                } catch (error) {
                    //ignore
                }
            },
            formatSeachObjCitizen: function (pSearchObj) {
                try {
                    if (BaseConfiguration.isDebug) console.log("formatSeachObjCitizen");
                    let retValue = pSearchObj;
                    if (this.citizenObj) {
                        if (
                            this.citizenObj.code ==
                            this.lsCitizenCategory[TRIP.ONE_WAY - 1].code
                        ) {
                            if(this.clientCode!=this.allClientCode.AZ) {
                            retValue.citizen = CITIZEN.MYANMAR;
                            }else{
                              retValue.citizen = CITIZEN.CANADIAN;  
                            }
                        } else {
                            retValue.citizen = CITIZEN.FOREIGNER;
                        }
                    }

                    return retValue;
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_ML_SEARCH,
                        "error in formatSeachObjCitizen",
                        err.toString(),
                        "formatSeachObjCitizen",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },
            assignDefaultCitizen: function (pdefaultCitizen) {
                try {
                    if (BaseConfiguration.isDebug) console.log("assignDefaultCitizen");

                    let retCitizen = null;

                    if (pdefaultCitizen == CITIZEN.MYANMAR.code || pdefaultCitizen == CITIZEN.CANADIAN.code) {
                        retCitizen = cloneData(this.lsCitizenCategory[TRIP.ONE_WAY - 1]);
                    } else {
                        retCitizen = cloneData(this.lsCitizenCategory[TRIP.ONE_WAY]);
                    }
                    this.onChangedCitizen(retCitizen);

                    return retCitizen;
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_ML_SEARCH,
                        "error in assignDefaultCitizen",
                        err.toString(),
                        "assignDefaultCitizen",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },
            triggerFlightDatePicker() {
                if (BaseConfiguration.isDebug) console.log("triggerFlightDatePicker");

                // this.onToggleBackdrop(true);
                // this.closePaxView();
                // this.addCssClass();
                for(let i=0;i<this.mlSearch.route.length;i++){
                     if (this.$refs['flightDatePicker'+i][0].isOpen) {
                  this.$refs['flightDatePicker'+i][0].isOpen = false;
                }
                }
                
                
            },
            //to focus departure dropdown
            openDatePicker(pIndex) {
                if (
                    this.isBackdropAdded == true &&
                    this.mlSearch.route[pIndex].from &&
                    this.mlSearch.route[pIndex].to
                ) {
                    this.$refs.flightDatePicker.isOpen = true;
                }
            },

            ///
            triggerDepCityPicker(pIndex) {
                try {
                    if (BaseConfiguration.isDebug) console.log("triggerDepCityPicker");
                        this.addCssClass();
                        this.triggerFlightDatePicker();
                    // if (!this.mlSearch.route[pIndex].from) {
                    //   this.$refs.fromMLCityPicker.activate();
                    // } else {
                    //   this.triggerFlightDatePicker();
                    // }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_ML_SEARCH,
                        "error in trigger",
                        err.toString(),
                        "trigger",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            ///to focus arrival dropdown
            triggerArrCityPicker() {
                try {
                    if (BaseConfiguration.isDebug) console.log("triggerArrCityPicker");
                    this.addCssClass();
                    
                    if (this.isBackdropAdded == true) {
                        //   this.triggerFlightDatePicker();
                           //this.$refs.toMLCityPicker.activate();
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_ML_SEARCH,
                        "error in triggerArrCityPicker",
                        err.toString(),
                        "triggerArrCityPicker",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },
            assigni18nObjByLang(pIndex) {
                let retValue;
                try {
                    if (BaseConfiguration.isDebug) console.log("assigni18nObjByLang");

                    retValue = {
                        night: this.$t("flightDatePicker.night"),
                        nights: this.$t("flightDatePicker.nights"),
                        "day-names": [
                            this.$t("flightDatePicker.sun"),
                            this.$t("flightDatePicker.mon"),
                            this.$t("flightDatePicker.tue"),
                            this.$t("flightDatePicker.wed"),
                            this.$t("flightDatePicker.thur"),
                            this.$t("flightDatePicker.fri"),
                            this.$t("flightDatePicker.sat")
                        ],
                        "check-in": formatDate(
                            this.mlSearch.route[pIndex].date,
                            "ddd, MMM DD"
                        ),
                        // this.$t("flightDatePicker.checkIn"),
                        // "check-out":"",
                        "check-out": formatDate(addDays(new Date(), 7), "ddd, MMM DD"),
                        "month-names": [
                            this.$t("flightDatePicker.jan"),
                            this.$t("flightDatePicker.feb"),
                            this.$t("flightDatePicker.mar"),
                            this.$t("flightDatePicker.apr"),
                            this.$t("flightDatePicker.may"),
                            this.$t("flightDatePicker.jun"),
                            this.$t("flightDatePicker.july"),
                            this.$t("flightDatePicker.aug"),
                            this.$t("flightDatePicker.sep"),
                            this.$t("flightDatePicker.oct"),
                            this.$t("flightDatePicker.nov"),
                            this.$t("flightDatePicker.dec")
                        ]
                    };
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_ML_SEARCH,
                        "error in assigni18nObjByLang",
                        err.toString(),
                        "assigni18nObjByLang",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },

            emitSearchObj() {
                try {
                    if (BaseConfiguration.isDebug) console.log("emitSearchObj");

                    //   if(!this.mlSearch.route[0].date){
                    //  this.mlSearch.route[0].date =new Date();
                    //   }
                    if (this.isValidSearch(this.mlSearch)) {
                        let formattedSearchObj = this.formatSeachObjCitizen(this.mlSearch);

                        this.storeSearchHistory(formattedSearchObj, new Date());
                        this.$emit("send", formattedSearchObj);
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_ML_SEARCH,
                        "error while emitting search object",
                        err.toString(),
                        "emitSearchObj",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },
            ///to get currency service url
            getOrgCurrencyServiceURL() {
                try {
                    if (BaseConfiguration.isDebug) console.log("getCurrencyServiceURL");
                    return SERVICE_URL.GET_ORG_CURRENCY;
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_ML_SEARCH,
                        "error while getting currency  service url",
                        err.toString(),
                        "getCurrencyServiceURL",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },


            toggleCheckIn() {
                this.$refs.flightDatePicker.checkIn = new Date(
                    this.mlSearch.route[0].date
                );
                this.$refs.flightDatePicker.checkOut = new Date(
                    this.mlSearch.route[0].date
                );
            },


            ///to save departure country value to search object
            assignDepToSearch(depVal, pIndex) {
                try {
                    if (BaseConfiguration.isDebug) console.log("assignDepToSearch");

                    var retSearchObj = this.mlSearch;
                    if (depVal != null) {
                        retSearchObj.route[pIndex].from = depVal;
                    }

                    return retSearchObj;
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_ML_SEARCH,
                        "error while assigning departure value to search",
                        err.toString(),
                        "assignDepToSearch",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            getDepWhileAssignArr(pArrValue, pIndex) {
                try {
                    if (BaseConfiguration.isDebug) console.log("getDepWhileAssignArr");
                    if (this.mlSearch.route.length - 1 > pIndex) {
                        this.mlSearch.route[pIndex + 1].from = pArrValue;
                        this.getArrivalLsForDep(this.mlSearch, pIndex + 1);
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_ML_SEARCH,
                        "error in getDepWhileAssignArr",
                        err.toString(),
                        "getDepWhileAssignArr",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            ///to assign arrival country value to mlSearch object
            assignArrToSearch(arrVal, pIndex, isSwapLoading) {
                try {
                    if (BaseConfiguration.isDebug) console.log("assignArrToSearch");

                    var mlSearchObj = this.mlSearch;
                    mlSearchObj.route[pIndex].to = arrVal;
                    if (!isSwapLoading) {
                        this.getDepWhileAssignArr(arrVal, pIndex);

                    }

                    return mlSearchObj;
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_ML_SEARCH,
                        "error while assigning arrival value to search",
                        err.toString(),
                        "assignArrToSearch",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },


            ///to get departure date
            getFromDate(selectedDate, pIndex) {
                try {
                    if (BaseConfiguration.isDebug) console.log("getFromDate");
                    this.mlSearch.route[pIndex].date = selectedDate;
                    // if(!this.isDatePickOpen){
                    // this.onToggleBackdrop(false);
                    this.formatMLSearchLsDates(pIndex);
                    // }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_ML_SEARCH,
                        "error in getFromDate ",
                        err.toString(),
                        "getFromDate",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },
            formatMLSearchLsDates(pIndex) {
                try {
                    if (BaseConfiguration.isDebug) console.log("formatMLSearchLsDates");
                    for (
                        let indexToChange = 0;
                        indexToChange < this.mlSearch.route.length;
                        indexToChange++
                    ) {
                        if (indexToChange > pIndex) {
                            if (
                                getDiffBtwDates(
                                    new Date(this.mlSearch.route[pIndex].date),
                                    new Date(this.mlSearch.route[indexToChange].date),
                                    "days"
                                ) > 0
                            ) {
                                this.mlSearch.route[indexToChange].date = this.mlSearch.route[
                                    pIndex
                                    ].date;
                            }
                        }
                   
                        this.isDatePicShow = false;
                        // let that = this;
                        Vue.nextTick(() => {///for a smooth update
                            this.isDatePicShow = true;
                        });
                       
                       
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_ML_SEARCH,
                        "error in formatMLSearchLsDates",
                        err.toString(),
                        "formatMLSearchLsDates",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            ///to get number of routes response from api
            async getRoutesResponse() {
                let retValue;
                try {
                    if (BaseConfiguration.isDebug) console.log("getRoutesResponse");

                    let getRoutesRequest = apiGetRoutes.buildRequest();

                    if (getRoutesRequest) {
                        // this.SET_AGENCY_REQ(getRoutesRequest); //save req in store
                        let getRouteResponse = await apiGetRoutes.getResponse(
                            getRoutesRequest
                        );

                        if (VALIDATE_SUCCESS_RES(getRouteResponse)) {
                            // this.SET_AGENCY_RES(getRoutesResponse); //save res in store

                            retValue = getRouteResponse.data.data;
                            this.SET_ROUTES_OBJ(retValue);
                        } else {
                            let error = getErrorMessage(getRouteResponse);

                            let isJwt = handleJWT(error);
                            if (!isJwt) {
                                this.alertValue = getErrorAlertValue(error);
                            }
                        }
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_ML_SEARCH,
                        "error while getting response from get Routes response API",
                        err.toString(),
                        "getRoutesResponse",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },

            ///method to get routes for particular country
            getRoutesByCountryCode() {
                try {
                    if (BaseConfiguration.isDebug) console.log("getRoutesByCountryCode");

                    // this.lsCountryRoute = []; //to clear the list

                    let countries = this.routesResponse.countries;
                    let airports = this.routesResponse.airports;
                    let routes = this.routesResponse.routes;
                    let listOfRoutes = [];

                    var routesGrpByList = GroupByList(routes, "depcode", "arrCombination"); ///list of routes grouped by depcode
                    for (let i = 0; i < Object.keys(countries).length; i++) {
                        for (let j = 0; j < Object.keys(airports).length; j++) {
                            let lsArrCodes = [];
                            if (
                                Object.values(countries)[i].countrycode ==
                                Object.values(airports)[j].countryid
                            ) {
                                for (let k = 0; k < routesGrpByList.length; k++) {
                                    if (
                                        routesGrpByList[k].depcode ==
                                        Object.values(airports)[j].airportcode
                                    ) {
                                        for (
                                            let l = 0;
                                            l < routesGrpByList[k].arrCombination.length;
                                            l++
                                        ) {
                                            lsArrCodes.push(
                                                routesGrpByList[k].arrCombination[l].arrcode
                                            );
                                        }
                                    }
                                }

                                let lsArrCodesForDep = {
                                    // "routes": 1,
                                    depcode: Object.values(airports)[j],
                                    arrcode: lsArrCodes
                                }; ///list of arrival for particular departure

                                listOfRoutes.push(lsArrCodesForDep); ///list of routes for particular country
                            }
                        }

                        let countryRoute = {
                            country: Object.values(countries)[i],
                            routeList: listOfRoutes
                        };
                        listOfRoutes = [];
                        this.lsCountryRoute.push(countryRoute);
                    }
                    let startCountry = cloneData(this.lsCountryRoute[0]);
                    for (let index = 0; index < this.lsCountryRoute.length; index++) {
                        const countryObj = this.lsCountryRoute[index];
                        if (
                            countryObj.country.countrycode ==
                            BaseConfiguration.defaultCountryValue
                        ) {
                            this.lsCountryRoute[0] = countryObj;
                            this.lsCountryRoute[index] = startCountry;
                            break;
                        }
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_ML_SEARCH,
                        "error while formatting routes",
                        err.toString(),
                        "getRoutesByCountryCode",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },
              getArrivalCodesForDep(pDepObj) {
      let retValue=[];
       try {
         if(BaseConfiguration.isDebug) console.log("getArrivalCodesForDep");
         let lsCountryRoute=cloneData(this.lsCountryRoute);
         for(let i=0;i<lsCountryRoute.length;i++){
           if(lsCountryRoute[i].country.countrycode==pDepObj.countryid){
             for(let j=0;j<lsCountryRoute[i].routeList.length;j++){
               if(lsCountryRoute[i].routeList[j].depcode.airportcode==pDepObj.airportcode){
                 retValue=lsCountryRoute[i].routeList[j].arrcode;
                 break;
               }
             }
           }
         }
       } catch (err) {
               let body = Logger.buildRequest(
                  COMPONENT_NAME.C_ML_SEARCH,
                 "error in getArrivalCodesForDep",
                 err.toString(),
                 "getArrivalCodesForDep",
                 LOG_TYPE.ERROR
               );
               Logger.getResponse(body);
             }
         return retValue;
       }, 
            ///to get list of arrival routes
            getArrivalRoutes(pValue, pIndex, isSwapLoading) {
                try {
                    if (BaseConfiguration.isDebug) console.log("getArrivalRoutes");

                    // this.isRouteChanged = false;
                    let lsOfRouteArrival = [];
                    if (this.routesResponse != null) {
                        let countries = this.routesResponse.countries;
                        let airports = this.routesResponse.airports;
                        let listOfRoutes = [];
                        var airGrpByList = GroupByList(
                            airports,
                            "countryid",
                            "arrCombination"
                        ); ///list of routes grouped by depcode

                        if (pValue.arrcode.length > 0) {
                            // if (
                            //   this.lsArrival.length > 0 &&
                            //   this.lsArrival.length - 1 == pIndex &&
                            //   this.lsArrival[pIndex].length > 0
                            // ) {

                            //   this.lsArrival[pIndex] = []; //to clear the list
                            // }
                            //  for (let i = 0; i < pValue.arrcode.length; i++) {
                            for (let i = 0; i < airGrpByList.length; i++) {
                                listOfRoutes = [];
                                for (let j = 0; j < pValue.arrcode.length; j++) {
                                    if (
                                        airGrpByList[i].countryid ==
                                        airports[pValue.arrcode[j]].countryid
                                    ) {
                                        let lsArrCodesForDep = {
                                            // "routes": 1,
                                            depcode: airports[pValue.arrcode[j]],
                                            arrcode: this.getArrivalCodesForDep(airports[pValue.arrcode[j]]),
                                        };
                                        listOfRoutes.push(lsArrCodesForDep);
                                    }
                                }
                                if (listOfRoutes.length > 0) {
                                    let countryRoute = {
                                        country: countries[airGrpByList[i].countryid],
                                        routeList: listOfRoutes
                                    };
                                    lsOfRouteArrival.push(countryRoute);
                                }
                            }

                            this.lsArrival[pIndex] = lsOfRouteArrival;
                            // console.log( this.lsArrival);
                            // console.log( this.lsCountryRoute);
                            this.SET_ML_ARR_LS(this.lsArrival);
                            this.mlSearch.route[pIndex].to = null;

                            let retSearchObj = this.assignDepToSearch(
                                this.mlSearch.route[pIndex].from,
                                pIndex
                            );
                            if (retSearchObj != null) {
                                this.mlSearch.route = retSearchObj.route;
                            } else {
                                this.mlSearch.route = null;
                            }

                            this.assignArrToSearch(this.mlSearch.route[pIndex].to, pIndex, isSwapLoading);
                        } else {
                            // this.getRoutesByCountryCode();

                            ///to clear the existing arrivals of the same index
                            this.lsArrival[pIndex] = [];
                            this.SET_ML_ARR_LS(this.lsArrival);
                        }
                    }
                } catch (err) {
                    // console.error(pIndex)
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_ML_SEARCH,
                        "error while formatting routes",
                        err.toString(),
                        "getArrivalRoutes",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            // // to validate search
            // isValidSearch(pSearch) {
            //   if (BaseConfiguration.isDebug) console.log("isValidSearch");
            //   try {
            //     let retValue = false;
            //     if (pSearch.trip == TRIP.ONE_WAY) {
            //       if (pSearch.route && pSearch.route.length == TRIP.ONE_WAY) {
            //         if (
            //           pSearch.route[TRIP.ONE_WAY - 1].from != null &&
            //           pSearch.route[TRIP.ONE_WAY - 1].to != null &&
            //           pSearch.route[TRIP.ONE_WAY - 1].from.depcode.airportcode !==
            //             pSearch.route[TRIP.ONE_WAY - 1].to.depcode.airportcode
            //         ) {
            //           if (
            //             getDiffBtwDates(
            //               new Date(pSearch.route[TRIP.ONE_WAY - 1].date),
            //               new Date(),
            //               "days"
            //             ) >= 0
            //           ) {
            //             if (this.currencyValidation(pSearch)) {
            //               retValue = this.paxValidation(pSearch);
            //             } else {
            //               retValue = false;
            //               this.showAlertMessage(this.$t("searchPage.selectCurrency"));
            //             }
            //           } else {
            //             retValue = false;
            //             this.showAlertMessage(this.$t("searchPage.dateInvalid"));
            //           }
            //         } else {
            //           retValue = false;
            //           this.showAlertMessage(this.$t("searchPage.routeInvalid"));
            //         }
            //       } else {
            //         retValue = false;
            //         this.showAlertMessage(this.$t("searchPage.routeLengthInvalid"));
            //       }
            //     } else if (pSearch.trip == TRIP.ROUND_TRIP) {
            //       if (pSearch.route && pSearch.route.length == TRIP.ROUND_TRIP) {
            //         if (
            //           pSearch.route[TRIP.ROUND_TRIP - 2].from != null &&
            //           pSearch.route[TRIP.ROUND_TRIP - 2].to != null &&
            //           pSearch.route[TRIP.ROUND_TRIP - 2].from.depcode.airportcode !==
            //             pSearch.route[TRIP.ROUND_TRIP - 2].to.depcode.airportcode
            //         ) {
            //           if (
            //             pSearch.route[TRIP.ROUND_TRIP - 1].from != null &&
            //             pSearch.route[TRIP.ROUND_TRIP - 1].to != null &&
            //             pSearch.route[TRIP.ROUND_TRIP - 1].from.depcode.airportcode !==
            //               pSearch.route[TRIP.ROUND_TRIP - 1].to.depcode.airportcode
            //           ) {
            //             if (
            //               getDiffBtwDates(
            //                 new Date(pSearch.route[TRIP.ROUND_TRIP - 1].date),
            //                 new Date(pSearch.route[TRIP.ROUND_TRIP - 2].date),
            //                 "days"
            //               ) >= 0
            //             ) {
            //               if (this.currencyValidation(pSearch)) {
            //                 retValue = this.paxValidation(pSearch);
            //               } else {
            //                 retValue = false;
            //                 this.showAlertMessage(this.$t("searchPage.selectCurrency"));
            //               }
            //             } else {
            //               retValue = false;
            //               this.showAlertMessage(
            //                 this.$t("searchPage.returnDateInvalid")
            //               );
            //             }
            //           } else {
            //             retValue = false;
            //             this.showAlertMessage(this.$t("searchPage.routeInvalid"));
            //           }
            //         } else {
            //           retValue = false;
            //           this.showAlertMessage(this.$t("searchPage.routeInvalid"));
            //         }
            //       } else {
            //         retValue = false;
            //         this.showAlertMessage(this.$t("searchPage.routeLengthInvalid"));
            //       }
            //     } else {
            //       retValue = false;
            //       this.showAlertMessage(this.$t("searchPage.tripInvalid"));
            //     }
            //     return retValue;
            //   } catch (err) {
            //     let body = Logger.buildRequest(
            //       COMPONENT_NAME.C_ML_SEARCH,
            //       "error in isValidSearch",
            //       err.toString(),
            //       "isValidSearch",
            //       LOG_TYPE.ERROR
            //     );
            //     Logger.getResponse(body);
            //   }
            // },

            // ///to validate a currency(if currency slected or not)
            // currencyValidation(pSearch) {
            //   try {
            //     if (BaseConfiguration.isDebug) console.log("currencyValidation");

            //     let retValue;
            //     if (pSearch.currency) {
            //       if (pSearch.currency.currency_code) {
            //         if (pSearch.currency.currency_code.code) {
            //           retValue = true;
            //         } else {
            //           retValue = false;
            //         }
            //       } else {
            //         retValue = false;
            //       }
            //     } else {
            //       retValue = false;
            //     }
            //     return retValue;
            //   } catch (err) {
            //     let body = Logger.buildRequest(
            //       COMPONENT_NAME.C_ML_SEARCH,
            //       "error in currencyValidation",
            //       err.toString(),
            //       "currencyValidation",
            //       LOG_TYPE.ERROR
            //     );
            //     Logger.getResponse(body);
            //   }
            // },

            //to valid pax counts(Adult,child,Infant)
            paxValidation(pSearch) {
                try {
                    if (BaseConfiguration.isDebug) console.log("paxValidation");

                    let retValue;

                    if (pSearch.pax.adultCount >= PAX_COUNT.MIN_ADULT) {
                        if (
                            pSearch.pax.adultCount <= PAX_COUNT.MAX_ADULT &&
                            pSearch.pax.childCount <= PAX_COUNT.MAX_CHILD &&
                            pSearch.pax.infantCount <= PAX_COUNT.MAX_INFANT
                        ) {
                            if (pSearch.pax.adultCount >= pSearch.pax.infantCount) {
                                retValue = true;
                            } else {
                                retValue = false;
                                this.showAlertMessage(this.$t("searchPage.infantEqualToAdult"));
                            }
                        } else {
                            retValue = false;
                            this.showAlertMessage(this.$t("searchPage.maxPax"));
                        }
                    } else {
                        retValue = false;
                        this.showAlertMessage(this.$t("searchPage.minAdult"));
                    }

                    return retValue;
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_ML_SEARCH,
                        "error in paxValidation",
                        err.toString(),
                        "paxValidation",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            // to show alert message
            showAlertMessage(value) {
                try {
                    if (BaseConfiguration.isDebug) console.log("showAlertMessage");
                    if (value) {
                        // this.showAlert = true;
                        this.alertValue = value;
                        this.currentAlertCounter = BaseConfiguration.defaultAlertCounter;
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_ML_SEARCH,
                        "error in showAlertMessage",
                        err.toString(),
                        "showAlertMessage",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },
            //to store search history in localstorage
            storeSearchHistory(pSearch, pDate) {
                if (BaseConfiguration.isDebug) console.log("storeSearchHistory");
                try {
                    let retValue = false;
                    let userId;
                    if (this.USER_ID) {
                        userId = this.USER_ID;
                    }
                    if (pSearch) {
                        //let obj = cloneData(this.search);
                        let obj = {
                            search: JSON.parse(JSON.stringify(pSearch)),
                            searchedDate: pDate
                        };
                        let searchHistory = this.getSearchHistory(userId);
                        //  for(let i=10;i<=searchHistory.length;i++){
                        //    searchHistory.shift();
                        //  }
                        if (searchHistory) {
                            if (
                                searchHistory.length >=
                                BaseConfiguration.flightSearchHistoryMaxLimit
                            )
                                searchHistory.shift();
                            searchHistory.push(obj);
                            setFlightSearchHisToLocal(JSON.stringify(searchHistory), userId);
                        }
                        retValue = true;
                    }
                    // else throw "invalid Search";
                    return retValue;
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_ML_SEARCH,
                        "error in storeSearchHistory",
                        err.toString(),
                        "storeSearchHistory",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            getSearchHistory(pUserId) {
                if (BaseConfiguration.isDebug) console.log("getSearchHistory");
                try {
                    let sHistory = [];
                    if (pUserId) {
                        let history = JSON.parse(getFlightSearchHisFromLocal(pUserId));

                        if (history && history.length > 0) {
                            sHistory = history;
                        }
                    }
                    return sHistory;
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.SEARCHPAGE,
                        "error in getSearchHistory",
                        err.toString(),
                        "getSearchHistory",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

            getActiveToRotate(pMlSearchObj) {
                let retValue = [];

                try {
                    if (BaseConfiguration.isDebug) console.log("getActiveToRotate");
                    let datePickLs=[];
                    for (let i = 0; i < pMlSearchObj.route.length; i++) {
                        let activeObj = {
                            isRotate: false
                        };
                        retValue.push(activeObj);
                       
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_ML_SEARCH,
                        "error in getActiveToRotate",
                        err.toString(),
                        "getActiveToRotate",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },
            rotate(pIndex) {
                // console.error(pIndex)
                if (BaseConfiguration.isDebug) console.log("rotate");
                // var element = document.getElementById("rotate-icon");
                // element.classList.toggle("re-rotate");
                this.isSwapLoading = true;
                this.rotateIconActiveLs[pIndex].isRotate = !this.rotateIconActiveLs[
                    pIndex
                    ].isRotate;

                this.mlSearch = this.swapCity(this.mlSearch, pIndex);
            },

            // toggleFlIcon(pIndex) {
            //   // this.swapIndex = pIndex;
            //   this.isFlIconRotate = !this.isFlIconRotate;
            // },

            swapCity(pSearch, pIndex) {
                let searchObj = pSearch;
                try {
                    if (BaseConfiguration.isDebug) console.log("swapCity");
                    // let retValue;
                    if (searchObj && searchObj.route[pIndex].from) {
                        // this.toggleFlIcon(pIndex);
                        let toPlace = cloneData(searchObj.route[pIndex].from);
                        let fromPlace = pSearch.route[pIndex].to;

                        depListIndex: for (
                            let index = 0;
                            index < this.lsCountryRoute.length;
                            index++
                        ) {
                            const depList = this.lsCountryRoute[index].routeList;
                            depIndex: for (let index = 0; index < depList.length; index++) {
                                const dep = depList[index];
                                if (
                                    fromPlace &&
                                    dep.depcode.airportcode == fromPlace.depcode.airportcode
                                ) {
                                    searchObj.route[pIndex].from = dep;
                                    this.getArrivalRoutes(searchObj.route[pIndex].from, pIndex, true);
                                    break depListIndex;
                                }
                            }
                        }
                        // let toPlace=pSearch.route[0].to;
                        if (this.lsArrival.length > 0 && this.lsArrival[pIndex]) {
                            for (
                                let index = 0;
                                index < this.lsArrival[pIndex].length;
                                index++
                            ) {
                                const arrList = this.lsArrival[pIndex][index].routeList;
                                for (let index = 0; index < arrList.length; index++) {
                                    const arr = arrList[index];
                                    if (arr.depcode.airportcode == toPlace.depcode.airportcode) {
                                        searchObj.route[pIndex].to = arr;
                                        this.assignArrToSearch(searchObj.route[pIndex].to, pIndex, true);
                                    }
                                }
                            }
                        }
                    } else {
                        // this.toggleFlIcon(pIndex);
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SEARCH,
                        "error in swapCity",
                        err.toString(),
                        "swapCity",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return searchObj;
            },

            ///to add flights by default max multi-city count
            assignObjectByMaxMl() {
                let retValue;
                try {
                    if (BaseConfiguration.isDebug) console.log("assignObjectByMaxMl");
                    this.rotateIconActiveLs.push({isRotate: false});

                    for (let i = 0; i < BaseConfiguration.multiCityLength.min - 1; i++) {
                        this.mlSearch.route.push(
                            this.getDefaultRouteObj(
                                this.mlSearch.route[this.mlSearch.route.length - 1]
                            )
                        );
                        this.rotateIconActiveLs.push({isRotate: false});

                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_ML_SEARCH,
                        "error in assignObjectByMaxMl",
                        err.toString(),
                        "assignObjectByMaxMl",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },

            ///
            getDefaultRouteObj(pMlSearchObj) {
                let retValue;
                try {
                    if (BaseConfiguration.isDebug) console.log("getDefaultRouteObj");
                    retValue = cloneData({
                        from: pMlSearchObj.to,
                        to: null,
                        date: pMlSearchObj.date
                    });
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_ML_SEARCH,
                        "error in getDefaultRouteObj",
                        err.toString(),
                        "getDefaultRouteObj",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },

            getArrivalRoutesForHis(pMlSearchObj) {

                try {
                    let searchObj = cloneDeep(pMlSearchObj);
                    if (BaseConfiguration.isDebug) console.log("getArrivalRoutesForHis");
                    for (let routeIndex = 0; routeIndex < searchObj.route.length; routeIndex++) {
                        if(searchObj.route[routeIndex].from){
                        this.getArrivalRoutes(searchObj.route[routeIndex].from, routeIndex);

                        }

                    }

                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_ML_SEARCH,
                        "error in getArrivalRoutesForHis",
                        err.toString(),
                        "getArrivalRoutesForHis",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }

            },
        },

        computed: {
            ...mapGetters("language", {
                lang: "GET_LANGUAGE"
            }),
            ...mapGetters("sCMultiCitySearch", {
                GET_ML_SEARCH_OBJ: "GET_ML_SEARCH_OBJ"
            }),
            ...mapGetters("sCMultiCitySearch", {
                GET_ML_ARR_LS: "GET_ML_ARR_LS"
            }),

            ...mapGetters("sCSearch", {
                routeObj: "GET_ROUTES_OBJ"
            }),
            ...mapGetters("sCOrgCurrencyDp", {
                currencyOptions: "GET_CURRENCY_OPTIONS"
            }),
            // ...mapGetters("sDashBoard", {
            //   AGENT_DET: "GET_AGENT_LOGO_DET_RES"
            // })
            ...mapGetters("sDashBoard", {
                USER_ID: "GET_USER_ID"
            })
        },
        async created() {
            try {
                if (BaseConfiguration.isDebug) console.log("created");
                if (this.searchMlObj && this.searchMlObj.route && this.searchMlObj.route.length >= 2) {
                    this.mlSearch = this.searchMlObj;
// console.error( this.mlSearch)
                    // console.error(this.lsArrival)
                } else if (this.GET_ML_SEARCH_OBJ) {
                    this.mlSearch = this.GET_ML_SEARCH_OBJ;
                } else {
                    this.assignObjectByMaxMl();
                }

                //   console.error(this.routeObj);
                if (this.routeObj) {
                    this.routesResponse = this.routeObj;
                } else {
                    this.routesResponse = await this.getRoutesResponse();
                }
                if (this.routesResponse != null) {
                    this.getRoutesByCountryCode();

                }


                if (this.rotateIconActiveLs.length <= 0) {
                    this.rotateIconActiveLs = this.getActiveToRotate(this.mlSearch);
                }
                if (this.mlSearch && this.mlSearch.route ) {
                    let tempMlsearchObj = cloneDeep(this.mlSearch);
                    this.getArrivalRoutesForHis(this.mlSearch);
                    this.mlSearch = tempMlsearchObj;
                }

                // if (this.searchMlObj && this.searchMlObj.route && this.searchMlObj.route.length > 2) {
                //     let tempMlsearchObj = cloneDeep(this.mlSearch);
                //     this.getArrivalRoutesForHis(this.mlSearch);
                //     this.mlSearch = tempMlsearchObj;
                // }
                // console.error( this.mlSearch)



            } catch (err) {
                let body = Logger.buildRequest(
                    COMPONENT_NAME.C_ML_SEARCH,
                    "error while created",
                    err.toString(),
                    "created",
                    LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
            }
        }
    };

    // script for toggle animation
</script>


<style>
    .slide-fade-enter-active {
        transition: all 0.3s ease;
    }

    .slide-fade-leave-active {
        transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
    }

    .slide-fade-enter,
    .slide-fade-leave-to {
        transform: translateX(10px);
        opacity: 0;
    }

    .test {
        background-color: rgb(167, 195, 218);
    }

    .nav-tabs .nav-link.active,
    .nav-tabs .nav-item.show .nav-link {
        color: #ffffff;
        background-color: #3e2ddd;
        border-color: #0f0096;
    }

    .radioOptions {
        padding: 5px;
    }
</style>




